<template>
    <div class="m-portlet m-portlet--head-sm" :class="{'m-portlet--collapse' : !isOpen }"  m-portlet="true" id="m_portlet_tools_4">
        <div class="m-portlet__head preview">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">{{ title }}</h3>
                </div>
            </div>
            <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item">
                        <a @click.prevent="togglePortlet" href="" m-portlet-tool="toggle" class="m-portlet__nav-link m-portlet__nav-link--icon" aria-describedby="tooltip_3xmztoxj1y"><i class="la la-angle-down"></i></a>
                        <div class="m-tooltip m-tooltip--portlet tooltip bs-tooltip-top" role="tooltip" id="tooltip_3xmztoxj1y" aria-hidden="true" x-placement="top" style="position: absolute; will-change: transform; visibility: hidden; top: 0px; left: 0px; transform: translate3d(288px, -32px, 0px);">
                            <div class="tooltip-arrow arrow" style="left: 39px;"></div>
                            <div class="tooltip-inner">Expand</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-portlet__body" m-hidden-height="345" :style="bodyStyle">
            <div class="custom_scroll">
                <table class="table table-striped- table-bordered table-hover table-checkable" id="m_table_1">
                    <thead class="thead-light">
                    <tr>
                        <th v-for="(index, key) in dataFields" :key="key">{{ labels[key] }}</th>
                        <th v-if="crudName === 'ingredients'"> {{ labels['file_link_to_object_product_ingredient'] }}</th>
                        <th v-if="crudName === 'ingredients'"> {{ labels['file_link_to_object_ingredient'] }}</th>
                        <th v-if="crudName === 'patents'"> {{ labels['file_link_to_object_patent'] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(data, index) in listData" class="larger-text">
                        <td v-for="(obj, key) in dataFields" :key="'td_' + key" :class="'td_' + key">
                            <span v-html="handleValue(data, obj.resource, obj.valueName, obj.idName, key, obj.customKey, obj.fallback)"></span>
                        </td>
                        <td v-if="crudName === 'ingredients'">
                          <show-files-link-to-object type="product_ingredients" :object-id="data.product_id + '_' + data.ingredient_id" :withDelete="false" v-if="data.product_id && data.ingredient_id"/>
                        </td>
                        <td v-if="crudName === 'ingredients'">
                          <show-files-link-to-object type="ingredients" :object-id="data.ingredient_id" :withDelete="false" v-if="data.ingredient_id"/>
                        </td>
                        <td v-if="crudName === 'patents'">
                          <show-files-link-to-object type="patents" :object-id="data.patent_id" :withDelete="false" v-if="data.patent_id"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import orderBy from '../../../assets/js/mixins';
import ShowFilesLinkToObject from '../../Upload/ShowFilesLinkToObject.vue';

export default {
  props: ['list', 'crudName', 'compareMode'],
  components: {
    ShowFilesLinkToObject,
  },
  mixins: [orderBy],
  data() {
    return {
      isOpen: true,
      patents: [],
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      previewProductBlocks: (state) => state.products.previewProductBlocks,
    }),
    ...mapGetters([
      'getName',
      'getResourceValue',
    ]),
    bodyStyle() {
      if (!this.isOpen) {
        return 'display: none; overflow: hidden; padding-top: 0px; padding-bottom: 0px;';
      }
      return '';
    },
    dataFields() {
      return this.previewProductBlocks[this.crudName];
    },
    title() {
      return this.labels.resources[this.crudName];
    },
    listData() {
      if (this.crudName === 'segmentations') {
        return this.orderBy(this.list, { key: 'theme_id', resource: 'themes' }, { key: 'segmentation_parent', resource: 'segmentations' }, { key: 'name' });
      } if (this.crudName === 'roles') {
        return this.orderBy(this.list, { key: 'role_id', resource: 'roles' });
      } if (this.crudName === 'patents') {
        return this.simpleOrderBy(this.list, 'name');
      }
      return this.simpleOrderBy(this.list, 'name');
    },
  },
  methods: {
    togglePortlet() {
      this.isOpen = !this.isOpen;
    },
    displayYesNo(value) {
      return value ? this.labels.yes : this.labels.no;
    },
    // handleValue is called for every key inside of each listData object
    // value = the whole data object
    // resource = gets value fo the resource defined in dataFields model (optional)
    // key = is the key we want to retrieve from the resource [] as defined in dataFields model (optional)
    // idName = is the name used to get the resource "id" as defined in dataFields model (optional)
    // objKey = object key name from dataFields model we are on in this iteration
    // customKey = is a custom property we user to get info from resource [] as defined in dataFields model (optional)
    handleValue(value, resource, key, idName, objKey, customKey, fallback) {
      if (value[key] && resource && idName && Array.isArray(value[key])) {
        return this.mapValues(value[key], idName, resource);
      } if (idName && value.hasOwnProperty(idName)) {
        return this.getResourceValue(value[idName], idName, resource, key);
      } if (value[key] && resource) {
        return this.getName(value[key], (customKey || key), resource);
      } if (value[key] && Array.isArray(value[key])) {
        if (value[key].length) {
          return value[key].join(', ');
        }
      } else if (value && key) {
        if (typeof value[key] !== 'undefined') {
          if (typeof value[key] === 'boolean') {
            return value[key] ? this.labels.yes : this.labels.no;
          }
          return value[key];
        } if (value[fallback] !== null) {
          if (typeof value[fallback] === 'boolean') {
            return value[fallback] ? this.labels.yes : this.labels.no;
          }
          return value[fallback];
        }
      } else if (value) {
        return value;
      }
      return '';
    },
    mapValues(values, idName, resource) {
      const names = [];
      values.map((value) => {
        names.push(this.getName(value, idName, resource));
      });
      return names.join(', ');
    },
    simpleOrderBy(dataArray, orderByKey) {
      return dataArray.sort((a, b) => {
        const posA = orderByKey ? a[orderByKey] : a;
        const posB = orderByKey ? b[orderByKey] : b;
        return posA && posB ? posA.localeCompare(posB, 'fr', { sensitivity: 'base' }) : 0;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/Preview/ProductData.vue